
import React from 'react';
import { SiderParentLabel, SiderItem } from 'components/layout/sidebar';
import { BASE_ROUTES, ANALYTICS_PANEL_ITEMS } from 'utils'
import { useLocation } from 'react-router';

export const AnalyticSide = () => {

    const { search } = useLocation();

    const items = [
        {
            key: 0,
            route: `${BASE_ROUTES.ANALYTICS_ROUTE}${ANALYTICS_PANEL_ITEMS.FLUX_ACTIVITY}${search}`,
            icon: "bi bi-graph-up",
            label: "Activity % Flux"
        },
        // {
        //     key: 1,
        //     route: `${BASE_ROUTES.ANALYTICS_ROUTE}${ANALYTICS_PANEL_ITEMS.PERFORMANCE}${search}`,
        //     icon: "bi bi-speedometer2",
        //     label: "Global Performance KPIs"
        // },
        {
            key: 1,
            route: `${BASE_ROUTES.ANALYTICS_ROUTE}${ANALYTICS_PANEL_ITEMS.AGENT_ACTIVITY}${search}`,
            icon: "bi bi-person-circle",
            label: "Activity % Agent"
        },
        {
            key: 2,
            route: `${BASE_ROUTES.ANALYTICS_ROUTE}${ANALYTICS_PANEL_ITEMS.QUALITY}${search}`,
            icon: "bi bi-lightning-charge-fill",
            label: "Quality KPIs"
        }
    ]

    return (
        <>
            <SiderParentLabel icon="bi bi-bar-chart-fill" label="Analytics" />
            <div className="overflow-auto" style={{ height: "80vh" }} >
                {items.map(item => <SiderItem {...item} />)}
            </div>
        </>
    );
}